import { withTranslation, WithTranslation } from 'react-i18next';
import React from 'react';
import TextField from '../../../form/inputField';
import PopoverContainer from '../../../popover/popover';
import { IAccountModel } from '../../../../helpers/models/accountModel';
import { ProfessionalStep2FormResultKeys } from './professionalStep2FormModel';
import {
    FORM_BUSINESS_NUMBER_MAX_LENGTH,
    FORM_GST_MAX_LENGTH,
    FORM_RT_MAX_LENGTH,
} from '../../utils/formValidation';

export interface IProfessionalStep2BusinessInformationsProps extends WithTranslation {
    readonly?: boolean;
    account: IAccountModel;
}

const ProfessionalStep2BusinessInformations = (
    props: IProfessionalStep2BusinessInformationsProps
) => {
    const { t, readonly, account } = props;
    return (
        <>
            <h2 className="header-3 header-3--purple registration_form_header">
                {t('form_professional_step_2_business_title')}
            </h2>
            <div className="registration-column-container">
                <TextField
                    fieldContainerClassName="registration-field registration-column-item"
                    fieldName={ProfessionalStep2FormResultKeys.ENTERPRISE_NUMBER}
                    fieldTitle="form_professional_step_2_enterprise_number"
                    fieldOptionalText="form_professional_step_2_enterprise_number_optional"
                    fieldDisabled={readonly}
                    fieldDisabledPopover={readonly}
                    fieldWeight={10}
                    fieldHiddenLabel="form_professional_step_2_business_title"
                    fieldTooltip={
                        <PopoverContainer
                            icon
                            className={'field-tooltip-icon'}
                            prefix={t('form_professional_step_2_enterprise_number')}
                        >
                            <>
                                <p className="body-medium">
                                    {t('form_professional_step_2_enterprise_number_popover_format')}
                                </p>
                                <p className="body-medium">
                                    {t('form_professional_step_2_enterprise_number_popover_examples')}
                                    <br />
                                    <span className="body-medium">
                                    {' '}
                                        {t(
                                            'form_professional_step_2_enterprise_number_popover_enterprise_account_number'
                                        )}
                                </span>
                                    <br />
                                    <span className="body-medium">
                                    {t(
                                        'form_professional_step_2_enterprise_number_popover_enterprise_number'
                                    )}
                                </span>
                                </p>
                                <p className="body-medium">
                                    {t(
                                        'form_professional_step_2_enterprise_number_popover_more_info_tel'
                                    )}
                                </p>
                            </>
                        </PopoverContainer>
                    }
                    type="text"
                    defaultValue={account.provider[0]?.businessNumber ?? 0}
                    maxLength={FORM_BUSINESS_NUMBER_MAX_LENGTH}
                />
                <TextField
                    fieldContainerClassName="registration-field registration-column-item"
                    fieldName={ProfessionalStep2FormResultKeys.TPS}
                    fieldTitle="form_professional_step_2_enterprise_tps"
                    fieldOptionalText="form_professional_step_2_enterprise_tps_optional"
                    fieldDisabled={readonly}
                    fieldHiddenLabel="form_professional_step_2_business_title"
                    type="text"
                    defaultValue={account.provider[0]?.gstHst ?? 0}
                    maxLength={FORM_GST_MAX_LENGTH}
                    fieldWeight={11}
                />
                <TextField
                    fieldContainerClassName="registration-field registration-column-item"
                    fieldName={ProfessionalStep2FormResultKeys.RT}
                    fieldTitle="form_professional_step_2_enterprise_rt"
                    fieldOptionalText="form_professional_step_2_enterprise_rt_optional"
                    fieldDisabled={readonly}
                    fieldHiddenLabel="form_professional_step_2_business_title"
                    type="text"
                    defaultValue={account.provider[0]?.rt ?? 0}
                    fieldWeight={12}
                    maxLength={FORM_RT_MAX_LENGTH}
                />
            </div>
        </>
    );
};

export default withTranslation()(ProfessionalStep2BusinessInformations);
